import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Theme } from '@routific/hive';

const Container = styled.div`
  width: 100%;
  min-height: 204px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: ${Theme.Spacing.xsSpacing};
  border-radius: ${Theme.BorderRadius.lgBorderRadius};
  padding: ${Theme.Spacing.mdSpacing} 0;
`;

const Title = styled.div`
  ${Theme.Typography.BodyStrong.toCssString()}
  text-align: center;
  color: ${Theme.Colors.textSecondary};
`;

const Description = styled.div`
  ${Theme.Typography.Caption.toCssString()}
  text-align: center;
  color: ${Theme.Colors.textSecondary};
`;

const NotFoundContent: React.FC = () => {
  const { t } = useTranslation('components');

  return (
    <Container data-cy="select-driver-not-found-empty">
      <Title>{t('assignDriver.notFound.title')}</Title>
      <Description>{t('assignDriver.notFound.description')}</Description>
    </Container>
  );
};

export default NotFoundContent;
